/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RoleGrant, RoleGrant$inboundSchema } from "./rolegrant.js";

export type Role = {
  /**
   * IDs of the agent principals assigned to this role.
   */
  agentIds?: Array<string> | undefined;
  createdAt: Date;
  /**
   * Human-readable description.
   */
  description: string;
  /**
   * Scope grants assigned to this role.
   */
  grants: Array<RoleGrant>;
  /**
   * Unique role identifier.
   */
  id: string;
  /**
   * Whether this is a built-in system role that cannot be deleted.
   */
  isSystem: boolean;
  /**
   * Number of members assigned to this role.
   */
  memberCount: number;
  /**
   * Display name of the role.
   */
  name: string;
  /**
   * Canonical principal URN for this role.
   */
  principalUrn: string;
  /**
   * Stable WorkOS role slug.
   */
  slug: string;
  updatedAt: Date;
};

/** @internal */
export const Role$inboundSchema: z.ZodMiniType<Role, unknown> = z.pipe(
  z.object({
    agent_ids: z.optional(z.array(z.string())),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    description: z.string(),
    grants: z.array(RoleGrant$inboundSchema),
    id: z.string(),
    is_system: z.boolean(),
    member_count: z.int(),
    name: z.string(),
    principal_urn: z.string(),
    slug: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "agent_ids": "agentIds",
      "created_at": "createdAt",
      "is_system": "isSystem",
      "member_count": "memberCount",
      "principal_urn": "principalUrn",
      "updated_at": "updatedAt",
    });
  }),
);

export function roleFromJSON(
  jsonString: string,
): SafeParseResult<Role, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Role$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Role' from JSON`,
  );
}
